import { ReportConfig } from './types';

const getDraftKey = (productId: string | number) =>
  `lca-report-draft:${String(productId)}`;

const parseJson = <T>(value: string | null, fallback: T): T => {
  if (!value) return fallback;
  try {
    return JSON.parse(value) as T;
  } catch {
    return fallback;
  }
};

export const saveDraftConfig = (
  productId: string | number,
  config: ReportConfig
) => {
  localStorage.setItem(getDraftKey(productId), JSON.stringify(config));
};

export const getDraftConfig = (
  productId: string | number
): ReportConfig | null => {
  const raw = localStorage.getItem(getDraftKey(productId));
  return parseJson<ReportConfig | null>(raw, null);
};

export const clearDraftConfig = (productId: string | number) => {
  localStorage.removeItem(getDraftKey(productId));
};
